export default function SplashPage() {
  window.location.replace('https://trackgood.io/')

  return null
}
